// vendors
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";

// components
import {
  getInitialEditorText,
  getPlainTextData,
} from "../../../../../Components/FlowBuilder/nodes/utils/editor";
import Input from "../../../Components/Input";
import InteractiveMessageBody from "../InteractiveMessage/InteractiveMessageBody";

type Header = {
  type: string;
  text?: string;
  value?: string;
  id?: string;
  link?: string;
  filename?: string;
};
type Props = {
  characterLimit: { header: number; body: number; footer: number };
  header: any;
  body: string;
  footer: string;
  onBodyChange: (text: string) => void;
  onHeaderChange: (data: Header) => void;
  onFooterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isActive?: boolean;
  isList?: boolean;
  type?: string;
};

const CatalogueInteractiveContent = ({
  characterLimit,
  header,
  body,
  footer,
  onBodyChange,
  onHeaderChange,
  onFooterChange,
  isActive,
  isList,
  type,
}: Props) => {
  return (
    <>
      {type === "product_list" && (
        <>
          <InputLabel
            shrink
            htmlFor="footer"
            sx={{ position: "static", transform: "none" }}
          >
            Header <sup style={{ color: "red" }}>*</sup>
          </InputLabel>
          <Input
            id="header"
            placeholder="Header"
            onChange={onHeaderChange}
            value={header?.text}
            {...{
              helperText: characterLimit.header ? (
                <Typography variant="body2" align="right">
                  {`${header?.text?.length}/${characterLimit.header}`}
                </Typography>
              ) : (
                ""
              ),
            }}
          />
        </>
      )}

      <InputLabel
        shrink
        htmlFor="footer"
        sx={{ position: "static", transform: "none" }}
      >
        Body <sup style={{ color: "red" }}>*</sup>
      </InputLabel>
      <InteractiveMessageBody
        text={body}
        maxTextLimit={characterLimit?.body}
        onChange={onBodyChange}
        error={getPlainTextData(getInitialEditorText(body)) === ""}
      />
      <FormControl variant="standard" fullWidth sx={{ mb: "16px" }}>
        <InputLabel
          shrink
          htmlFor="footer"
          sx={{ position: "static", transform: "none" }}
        >
          Footer <span style={{ color: "#eeeeee" }}>(optional)</span>
        </InputLabel>
        <Input
          id="footer"
          placeholder="Footer"
          onChange={onFooterChange}
          value={footer}
          {...{
            helperText: characterLimit.footer ? (
              <Typography variant="body2" align="right">
                {`${footer.length}/${characterLimit.footer}`}
              </Typography>
            ) : (
              ""
            ),
          }}
        />
      </FormControl>
    </>
  );
};

export default CatalogueInteractiveContent;
